import { formatDisplayDateTime4 } from '@/utils/date'

export const mulAcctPaymentViewMixin = {
  data() {
    return {
      mulAcctPayFilterForm: {
        branch: null,
        accountNo: null,
        documentNo: null,
        transactionDateFrom: null,
        transactionDateTo: null,
        currency: null
      },
      mulAcctPayFilterLabel: {
        branch: 'Branch',
        accountNo: 'Account No.',
        documentNo: 'Document No.',
        transactionDateFrom: 'Transaction Date From',
        transactionDateTo: 'Transaction Date To',
        currency: 'Currency'
      },
      mulAcctPayForm: {
        accountList: [],
        actionName: null,
        branch: null,
        accountNo: null,
        documentNo: null,
        transactionType: 'Z',
        docAE: true,
        transactionDate: null,
        payTo: null,
        bankNo: null,
        fromBank: null,
        fund: null,
        accountNoSuffix: '',
        cashBook: null,
        gstIO: null,
        gstStatus: null,
        gstRate: (0.00).toFixed(2),
        amountCurr: null,
        amount: (0.00).toFixed(2),
        gstAmountCurr: null,
        amountCurrRate: (0.00).toFixed(2),
        gstAmountAE: true,
        gstAmount: (0.00).toFixed(2),
        netAmountCurr: null,
        netAmount: (0.00).toFixed(2),
        bankAmountCurr: null,
        bankAmountAE: true,
        bankAmount: (0.00).toFixed(2),
        bankAmountCurrRate: (0.00).toFixed(2),
        bankChargesCurr: null,
        bankCharges: (0.00).toFixed(2),
        bankTotalAmountCurr: null,
        bankTotalAmount: (0.00).toFixed(2),
        bankTotalLocalCurr: null,
        bankTotalLocalAE: true,
        bankTotalLocal: (0.00).toFixed(2),
        bankTotalLocalCurrRate: (0.00).toFixed(2),
        chequeNo: null,
        prtCheque: false,
        isDeptMand: false,
        printDocument: null,
        policyNo: null,
        companyName: null,
        docAddress1: null,
        docAddress2: null,
        docAddress3: null,
        docAddress4: null,
        postalCode: null,
        details: null,
        statementRef: null,
        department: null,
        insuredName: null,
        claimNo: null,
        gstRegNo: null,
        taxInvoiceNo: null,
        isExistDocNo: null,
        docNoAe: false,
        insdRefNo: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      mulAcctPayLabel: {
        branch: 'Branch',
        documentNo: 'Document No',
        transactionType: 'Transaction Type',
        docAE: 'Auto Payment No.',
        transactionDate: 'Transaction Date',
        payTo: 'Pay To',
        fromBank: 'From Bank',
        fund: 'Fund',
        accountNoSuffix: 'Suffix',
        cashBook: 'Cash Book',
        gstIO: 'GST IO',
        gstStatus: 'Status',
        gstRate: 'Rate',
        amountCurr: 'Amount Currency',
        amount: 'Amount',
        gstAmountCurr: 'GST Amount Currency',
        gstAmount: 'GST Amount',
        netAmountCurr: 'Net Amount Currency',
        netAmount: 'Net Amount',
        bankAmountCurr: 'Bank Amount Currency',
        bankAmount: 'Bank Amount',
        bankChargesCurr: 'Bank Charges Currency',
        bankCharges: 'Bank Charges',
        bankTotalAmountCurr: 'Bank Total Amount Currency',
        bankTotalAmount: 'Bank Total Amount',
        bankTotalLocalCurr: 'Bank Total Local Currency',
        bankTotalLocal: 'Bank Total Local',
        chequeNo: 'Cheque No',
        prtCheque: 'Print Cheque',
        printDocument: 'Print Document',
        addressTo: 'Address To',
        policyNo: 'Policy',
        companyName: 'Name',
        docAddress1: 'Address 1',
        docAddress2: 'Address 2',
        docAddress3: 'Address 3',
        docAddress4: 'Address 4',
        postalCode: 'Postal Code',
        details: 'Details',
        statementRef: 'Statement Reference',
        department: 'Department',
        insuredName: 'Insured Name',
        claimNo: 'Claim No',
        gstRegNo: 'GST Reg No',
        taxInvoiceNo: 'Their Tax Invoice No',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      accountList: [],
      branches: [],
      currencies: [],
      gstIO: [
        { label: '', value: 'B' },
        { label: 'Output', value: 'O' },
        { label: 'Input', value: 'I' }
      ],
      printDocOpts: [
        { label: 'Immediately', value: 'I' },
        { label: 'Later', value: 'L' },
        { label: 'No', value: 'N' }
      ],
      addressToOpts: [
        { label: 'Agent', value: 'A' },
        { label: 'Insured', value: 'I' },
        { label: 'Entered as below', value: 'E' }
      ],
      showBankNoHelpList: false,
      showAcctSufHelpList: false,
      showCurrencyHelpList: false,
      showAcctPolicyHelpList: false,
      showPayToHelpList: false,
      showClmHelpList: false,
      selectAcctPayColumns: ['payTo', 'accountNoSuffix', 'gstIO', 'gstStatus', 'gstRate', 'amount', 'gstAmountAE', 'gstAmount', 'netAmount', 'bankAmountAE', 'bankAmount', 'bankCharges', 'bankTotalAmount', 'bankTotalLocalAE', 'bankTotalLocal'],
      mulAcctPayColumns: [
        { text: 'Pay To', value: 'payTo' },
        { text: 'Suffix', value: 'accountNoSuffix' },
        { text: 'GST', value: 'gstIO' },
        { text: 'Status', value: 'gstStatus' },
        { text: 'Rate', value: 'gstRate' },
        { text: 'Payment ', value: 'amount' },
        { text: 'A/E', value: 'gstAmountAE' },
        { text: 'GST', value: 'gstAmount' },
        { text: 'Net', value: 'netAmount' },
        { text: 'A/E', value: 'bankAmountAE' },
        { text: 'Bank Amt', value: 'bankAmount' },
        { text: 'Charges', value: 'bankCharges' },
        { text: 'Total', value: 'bankTotalAmount' },
        { text: 'A/E', value: 'bankTotalLocalAE' },
        { text: 'Local Total', value: 'bankTotalLocal' }
      ],
      btnSaveList: false,
      nowDT: formatDisplayDateTime4(new Date()),
      createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
    }
  }
}
